import apiFetch from '../apiFetch'

export default function (token, documentTypeMetadata) {
  return apiFetch({ endPoint: 'Metadata', method: 'POST', body: documentTypeMetadata, token: token })
}
